import { defineStore } from 'pinia'

export const Rep_Steps = defineStore('rep_steps', {
    state: () => {
        return { rep_steps:
            [
                {
                    name: 'Выбор договора',
                    status: false
                },
                {
                    name: 'Генерация отчёта',
                    status: false
                },
                {
                    name: 'Редактирование отчёта',
                    status: false
                },
                {
                    name: 'Печать отчёта',
                    status: false
                }
            ]
        }
    },
    actions: {
        get() {
            return this.rep_steps
        },
        set(value) {
            this.rep_steps = value
        }
    }
})

export const Rep_Loading = defineStore('rep_loading', {
    state: () => {
        return { rep_loading: false }
    },
    actions: {
        get() {
            return this.rep_loading
        },
        set(value) {
            this.rep_loading = value
        }
    }
})

export const Rep_Step = defineStore('rep_step', {
    state: () => {
        return { rep_step: 0 }
    },
    actions: {
        get() {
            return this.rep_step
        },
        set(value) {
            this.rep_step = value
        }
    }
})

export const Rep_Contracts = defineStore('rep_contracts', {
    state: () => {
        return { rep_contracts: [] }
    },
    actions: {
        get() {
            return this.rep_contracts
        },
        set(value) {
            this.rep_contracts = value
        }
    }
})

export const Rep_Contract = defineStore('rep_contract', {
    state: () => {
        return { rep_contract: null }
    },
    actions: {
        get() {
            return this.rep_contract
        },
        set(value) {
            this.rep_contract = value
        }
    }
})

export const Rep_Pages = defineStore('rep_pages', {
    state: () => {
        return { rep_pages: 1 }
    },
    actions: {
        get() {
            return this.rep_pages
        },
        set(value) {
            this.rep_pages = value
        }
    }
})

export const Rep_Period = defineStore('rep_period', {
    state: () => {
        return {
            rep_period: null
        }
    },
    actions: {
        get() {
            return this.rep_period
        },
        set(value) {
            this.rep_period = value
        }
    }
})

export const Rep_Edite_Mode = defineStore('rep_mode', {
    state: () => {
        return { rep_mode: false }
    },
    actions: {
        get() {
            return this.rep_mode
        },
        set(value) {
            this.rep_mode = value
        }
    }
})
